import React, { useRef } from "react";
import { getWindowInnerDimensions } from "../../utils/WindowDimensions";
import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import EntryCounter from "./EntryCounter";
import { PlayAgainButton } from "./PlayAgainButton";
import { LeaderboardLink } from "./LeaderBoardLink";
import { ScoreDisplay } from "./ScoreDisplay";
import { UnlockWinnings } from "./UnlockWinnings";
import { Countdown } from "./Countdown";
import backgroundShine from "./Images/Group 627712.svg";
import TimeoutIcon from "./Images/shutterstock_2174067755 1.svg";
import ThumbsUp from "./Images/ThumbsUp3D 2.svg";
import winnerScreenTokenClash from "./Images/looser_graphic 1.svg";
import leaderboardicon from "./Images/Vector.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../constant";
import gamePlayBg from "../../assets/bg-pattern.svg";
import { _isEmpty, _isNil } from "../../utils/helpers/zupeeLodash";
import { TIMEOUT_FOR_ONE_SEC } from "../../appConstants/AppConstant";
import Loader from "../../components/Loader";
import winningBg from "../../assets/winningBg.svg";
import { useWinningBannerApi } from "../../api/useWinningBannerApi";
import { FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../utils/helpers/common";
import { FACEBOOK } from "../../utils/helpers/constants";
interface ResultsScreenInterface {
  title: string;
  description: string;
  rankLabel: string;
  currentRank: number;
  scoreLabel: string;
  score: number;
  timerText: string;
  timerMs: number;
  isInstantEntryFeeCreditEnabled: boolean;
  playAgainCtaText: string;
  unlockMaxWinnings: string;
  leftAttempts: number;
  instantRefundAmountText: string;
  type: string;
  gameName: string;
  ltid: string;
}
interface WinningBannerData {
  data?: {
    banner?: {
      imageUrl?: string;
      bannerText?: string;
      cta: {
        value?: string;
        type?: string;
      };
    };
  };
}

const ResultScreen = () => {
  const [windowSize, setWindowSize] = useState(getWindowInnerDimensions());
  const [imageSrc, setimageSrc] = useState("");
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const resultData = location?.state || {};
  const hasTrackedRef = useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);
  const {
    title = "",
    description,
    rankLabel,
    currentRank,
    scoreLabel,
    score,
    instantRefundAmountText = "",
    timerText,
    timerMs,
    type,
    isInstantEntryFeeCreditEnabled = false,
    playAgainCtaText,
    unlockMaxWinnings,
    leftAttempts,
    leftAttemptsText,
    gameName = "ludonx",
    ltid,
    isTimeOut,
  } = resultData;
  const remainingTime = Math.abs(timerMs);
  // Then update the access with proper type checking
  const { winningBannerData } = useWinningBannerApi({
    gameName: "ludonx",
    ltid,
  }) as { winningBannerData: WinningBannerData };
  const bannerData = winningBannerData?.data?.banner;
  const scores = [
    { label: `${rankLabel}`, value: `#${currentRank}` },
    { label: `${scoreLabel}`, value: `${score}` },
  ];

  const handleNavigation = (path: "tournament" | "leaderboard") => {
    navigate(
      `${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/${path}?gameName=${gameName}&ltid=${ltid}`,
      { replace: true }
    );
  };

  const handleBannerClick = () => {
    if (!_isEmpty(bannerData?.cta)) {
      window.open(bannerData?.cta?.value, bannerData?.cta?.type === "EXTERNAL_LINK" ? "_blank" : "_self");
      // navigate(NAVIGATION_ROUTES.EXTERNAL_LINKS, {
      //   state: {
      //     url: bannerData?.cta?.value,
      //   },
      // });
      // window.open(bannerData?.cta?.value, "_blank");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getWindowInnerDimensions());
    };
    const source = getImageSource();
    setimageSrc(source);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, TIMEOUT_FOR_ONE_SEC);
  }, []);

  const getImageSource = () => {
    if (isTimeOut) {
      return TimeoutIcon;
    } else if (isInstantEntryFeeCreditEnabled) {
      return ThumbsUp;
    } else {
      return winnerScreenTokenClash;
    }
  };

  if(_isEmpty(resultData)) {
    navigate(NAVIGATION_ROUTES.HOME, {replace: true});
    return null;
  }
  if (isLoading) return <Loader />;

  return (
    <>
      <div
        className={clsx(styles.boardBg)}
        style={{
          backgroundImage: `url(${gamePlayBg})`,
          width: `${windowSize.width}px`,
          height: `${windowSize.height}px`,
        }}
      >
        <div className={styles.modalBody}>
          {/* <img className={styles.backgroundShine}
              loading='lazy'
              src={backgroundShine}
              alt=''
          ></img> */}
          <div className={clsx(styles.timeoutContainer)}>
            {/* 
            <div className={styles.OverlayImage}>
                    <img
                  alt='overlayimage'
                  src='https://cdn.builder.io/api/v1/image/assets/TEMP/c3492d0e97b2bba03a8f5d89357e3ee206fb07c61d210cfa79b1ab4af76041e4?placeholderIfAbsent=true&apiKey=63300f75e5f749af81f7b72c8da30c7d' 
                  />
            </div>
            */}
            <div className={styles.timeoutElements}>
              <div className={styles.timeoutIcon}>
                <img loading="lazy" src={imageSrc} alt="icon" />
              </div>

              <div className={styles.titleContainer}>
                {!_isEmpty(title) && (
                  <p
                    className={clsx(
                      styles.title,
                      "fontSizeMd fontWeightBolder"
                    )}
                  >
                    {title}
                  </p>
                )}
                {!_isEmpty(description) && (
                  <p
                    className={clsx(
                      styles.message,
                      "fontSizeSm12 fontWeightBold"
                    )}
                  >
                    {description}
                  </p>
                )}
              </div>
              <div className={styles.scoreBoardStyle}>
                <div className={styles.scoreBoardContainer}>
                  <div className={styles.scoreBoard}>
                    <div className={styles.scoreWrapper}>
                      {scores.map((item, index) => (
                        <React.Fragment key={item.label}>
                          <ScoreDisplay label={item.label} value={item.value} />
                          {index < scores.length - 1 && (
                            <div className={styles.divider} />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
                {!_isEmpty(bannerData?.imageUrl) && (
                  <div className={styles.winningBg} onClick={handleBannerClick}>
                    <div className={styles.winningText}>
                      {bannerData?.bannerText}
                    </div>
                    <img src={bannerData?.imageUrl} alt="winningBg" />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={clsx(styles.bottomContainer)}>
            {!_isEmpty(unlockMaxWinnings) && isInstantEntryFeeCreditEnabled && (
              <UnlockWinnings />
            )}
            {!_isNil(timerMs) && !isInstantEntryFeeCreditEnabled && (
              <Countdown
                millisecondsleft={remainingTime}
                gameName={gameName}
                ltid={ltid}
                label={timerText}
              />
            )}
            <div className={styles.FooterElement}>
              {!_isNil(leftAttempts) && (
                <EntryCounter EntriesLeft={leftAttemptsText} />
              )}
              <PlayAgainButton onClick={() => handleNavigation("tournament")} disabled={leftAttempts === 0} />
              <LeaderboardLink
                iconSrc={leaderboardicon}
                onclick={() => handleNavigation("leaderboard")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultScreen;